const actions = {
	SET_ELIGIBLE_DEPENDENT: "SET_ELIGIBLE_DEPENDENT"
};

export default actions;
